const centeredCarousel = {
  key: 'centered-carousel',
  componentKey: 'carousel',
  label: 'Centered carousel'
};

export default centeredCarousel;
